import gCard from "@/components/g-card/g-card.vue";
import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import OrcamentoViewModel from "../../../shared/view-models/OrcamentoViewModel";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import gSteps from "@/components/g-steps/g-steps.vue";
import { defineComponent } from "vue";
import AccountLoged from "@/shared/mixins/AccountLoged";



const name = 'ProdutoNovoInicio'
export default defineComponent({
  name,

  components: {
    'g-card':gCard,
    'g-button': gButton,
    'g-form': gForm,
    'g-steps' : gSteps
  },

  props: { },

  mounted () {

    this.popularDropDownEmpresa();
    this.atualizaEmpresaRepresentante();

    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })


  },

  updated () { },

  data () {
    return {

      CidadeId:null,
      ClientesArray:[],
      ClienteSelecionado:null,
      EmpresaArray:[],
      EmpresaSelecionada:null,
      escritobotao: true,
      NovoOrcamento: new OrcamentoViewModel(0),
      OrcamentoId:null,
      PrdodutoId:null,
      RepresentantesArray:[],
      RepresentanteSelecionado:null,
      teste: null,
      timer: null,
    }
  },

  mixins:[AccountLoged],

  methods: {
    // procurarEmpresa(){
    //   this.popularDropDownEmpresa()
    // },
    atualizaEmpresaRepresentante(){
      this.RepresentantesArray = this.$store.state.RepresentanteArray;
      this.NovoOrcamento.EmpresaId = this.$store.state.empresaSelecionadaId;
      this.NovoOrcamento.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },
    continuarpt2 () {
      if(this.NovoOrcamento.ClienteId != null && this.NovoOrcamento.EmpresaId != null && this.NovoOrcamento.RepresentanteId!=null ){

        this.gerarProdutoNovo()
        }
      else{
        this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'Cliente, Unidade e Representante são compos obrigadórios', life: 5000 });
      }

      },


      popularDropDownEmpresa(){
        this.EmpresaArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
        this.atualizaEmpresaRepresentante()
      },

    gerarProdutoNovo(){
      this.escritobotao = false
      setTimeout(() => {
        this.getCidadeId()
      } , 1100)

    },

    getCidadeId(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/GetByCliente',
        data: {
        Id: this.NovoOrcamento.ClienteId,
        }
      })
        .then((response) => {
          if(response.data.data === null) {
            return

          }else{
            this.NovoOrcamento.CidadeId = response.data.data[0].cidadeId
            this.gerarOrcamentoNovo()
          }
        })
        .catch(() => {
        });
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClientesArray = ClienteController.getClienteDropDownsByNome(event, this.NovoOrcamento.EmpresaId, this.NovoOrcamento.RepresentanteId).ClientesArray;
      }, 1000);
    },

    gerarOrcamentoNovo(){
      OrcamentoController.gerarNovoOrcamento(this.NovoOrcamento)
      .requisicao
        .then((response)=>{
          if(response.data.data === null) {
            return
          } else {
            this.OrcamentoId = response.data.data
            this.$router.push(`/produto-novo/${this.OrcamentoId}/infos-cliente`)
          }
        });
    },
    zerarcampos(){
      this.RepresentanteSelecionado = null;
      this.ClienteSelecionado = null;
    },
    Gerarinformaçãocliente(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'orcamento/post',
        data: {
          ClienteId: this.ClienteSelecionado,
          RepresentanteId: this.RepresentanteSelecionado,
          EmpresaId: this.EmpresaSelecionada,
          ProdutoId:this.ProdutoId,
          Cidadeid:this.CidadeId,

        }
      })
        .then((response) => {

          if(response.data.data === null) {
            return
          }else{
            this.OrcamentoId=response.data.data
          }
          this.$router.push(`/produto-novo/${this.OrcamentoId}/infos-cliente`)

        })
        .catch(() => {
        });
    },
     filter(e){
      this.ClientesArray =  this.ClientesArrayAux._value.filter((Element) => Element.nomeFantasia.includes(e.value) || Element.razaoSocial.includes(e.value))
    },

    buscarRepresentante(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.RepresentantesArray = RepresentanteController.getRepresentanteByPesquisaEUsuario(event).RepresentanteArray;
      }, 1000);
    },

  },

  computed: { },

});